module.exports = __webpack_public_path__ + "static/img/sub_banner6.2aeed25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/sub_banner6.png
// module id = 1807
// module chunks = 5